import { lazy } from 'react';
import { React, Suspense } from 'libs/react';
/**
 * @const QuillEditor
 * @hidden
 */
const QuillEditor = lazy(() => import('libs/quill/reactQuill'));
/**
 * Quill editor loaded on first render, so pages without an editor do not
 * download Quill.
 *
 * @component LazyReactQuill
 * @since 1.0.0
 */
export function LazyReactQuill(props) {
    return (React.createElement(Suspense, { fallback: null },
        React.createElement(QuillEditor, Object.assign({}, props))));
}
